// @ts-nocheck
import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import styles from './Switch.module.scss'

export const Switch = React.forwardRef(
  (
    {
      error,
      fieldClassName,
      id,
      name,
      placeholder,
      value,
      onBlur,
      onChange,
      isDisabled = false,
      isRequired = false,
    },
    ref,
  ) => (
    <input
      className={cx(styles.switch, {
        [fieldClassName]: Boolean(fieldClassName),
        [styles.invalid]: Boolean(error),
      })}
      type="checkbox"
      checked={value}
      disabled={isDisabled}
      required={isRequired}
      {...{ id, name, placeholder, ref, onBlur, onChange }}
    />
  ),
)

export const ControlledSwitch = ({
  control,
  error,
  fieldClassName,
  id,
  name,
  isDisabled,
  isRequired,
}) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Switch
        {...{
          error,
          fieldClassName,
          id,
          name,
          ref,
          value,
          onBlur,
          onChange,
          isDisabled,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
